import { RouteConfig } from 'vue-router'

// Maintenance Record (MR) components
const PaymentIndex = () => import(/* webpackChunkName: "payment-group" */ '@/pages/payment/PaymentIndex.vue')
const StripeIndex = () => import(/* webpackChunkName: "payment-group-stripe" */ '@/pages/payment/StripeIndex.vue')
const StripeListHandler = () => import(/* webpackChunkName: "payment-group-stripe" */ '@/pages/payment/StripeListHandler.vue')
const StripePayoutsIndex = () => import(/* webpackChunkName: "payment-group-stripe-payouts" */ '@/pages/payment/StripePayoutsIndex.vue')
const StripePayoutsListHandler = () => import(/* webpackChunkName: "payment-group-stripe-payouts" */ '@/pages/payment/StripePayoutsListHandler.vue')
const StripePayoutDetail = () => import(/* webpackChunkName: "payment-group-stripe-payouts" */ '@/pages/payment/StripePayoutDetail.vue')
const PaymentDetail = () => import(/* webpackChunkName: "payment-group" */ '@/pages/payment/PaymentDetail.vue')
const PaymentListHandler = () => import(/* webpackChunkName: "payment-group" */ '@/pages/payment/PaymentListHandler.vue')
const PaymentPrintIndex = () => import(/* webpackChunkName: "payment-group" */ '@/pages/payment/PaymentPrintIndex.vue')
const PaymentReceiptPrint = () => import(/* webpackChunkName: "payment-group" */ '@/pages/payment/print/PaymentReceiptPrint.vue')


const SlidePage = () => import('@/pages/SlidePage.vue')
const UnderConstruction = () => import(/* webpackChunkName: "generic-pages-group" */'@/pages/UnderConstruction.vue');

const route: RouteConfig = {
  path: 'payment',
  component: SlidePage,

  children: [
    //
    // ─── STRIPE PAYOUTS ──────────────────────────────────────────────────────
    //
    {
      path: 'stripe-payouts',
      component: StripePayoutsIndex,
      name: 'Stripe Payouts',

      children: [
        {
          path: '',
          component: StripePayoutsListHandler,
          name: 'Stripe Payouts List',
        },
        {
          path: ':id',
          component: StripePayoutDetail,
          props: true,
          name: 'Stripe Payout Detail',
        }
      ]
    },

    //
    // ─── STRIPE SECTION ──────────────────────────────────────────────────────
    //
    {
      path: 'stripe',
      component: StripeIndex,
      name: 'Stripe',

      children: [
        {
          path: '',
          component: StripeListHandler,
          name: 'Stripe List',
        }
      ]
    },

    //
    // ─── MAIN PAYMENT SECTION ───────────────────────────────────────────────
    //
    {
      path: '',
      component: PaymentIndex,
      name: 'Payment Home',

      children: [
        {
          path: '',
          component: PaymentListHandler,
          name: 'Payment List',
        },
        {
          path: ':id',
          component: PaymentDetail,
          props: true,
          name: 'Payment Detail',
        }
      ]
    },

    //
    // ─── PRINT SECTION ─────────────────────────────────────────────────────
    //
    {
      path: 'print',
      component: PaymentPrintIndex,
      name: 'PaymentPrint',

      children: [
        {
          path: ':id',
          component: PaymentReceiptPrint,
          props: true,
          name: 'Print Payment Receipt',
        }
      ]
    },

    //
    // ─── FALLBACK (UNDER CONSTRUCTION) ──────────────────────────────────────
    //
    {
      path: '*',
      component: UnderConstruction,
      name: 'Underconstruction',
    }
  ]
}

export default route;
